import React from 'react';
import MypageSolutionContainer from 'containers/MypageSolutionContainer/MypageSolutionContainer';

export default function MypageSolutionPage() {
    return (
        <MypageSolutionContainer />
    )
}
